























































































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {Vue, Component} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {
  Mall,
  Partner,
  Grade,
  Group,
  GetStatisticsSalesCategoryRequest,
  GetStatisticsSalesCategorySummaryRequest,
  GetStatisticsSalesCategory,
  GetStatisticsSalesCategorySummary, GetPartnersRequest,
} from 'supporter';
import CompCheckBoxButton from '@/components/common/CompCheckBoxButton.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {CategroyType, DepthType} from '@/types/product';
import ClickOutside from 'vue-click-outside';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {getFirstAndEndDay, getToday, addMonth} from '@/utils/dateUtils';
import {DEFAULT_DATE_RANGE, DEFAULT_TIME_RANGE} from '@/pro/components/common/datepicker/dateRange'
import {PARTNERS_SEARCH_TYPE, PARTNERS_STATUS} from '@/views/statistic/common/getPartners'
import debounce from 'lodash.debounce';
import BrandSearcher from '@/components/product/BrandSearcher.vue';

const mallModule = namespace('mall');

@Component({
  components: {CompSelectBox, CompCheckBoxButton, PageFormSelect, PeriodDateCalendar, BrandSearcher},
  directives: {ClickOutside}
})
export default class SearchCategoryForm extends Vue {
  // 쇼핑몰
  @mallModule.Getter('mallsGlobal')
  private malls!: Mall[];
  private mallNo: number = 0;
  private partnerName: string = '';
  private brandName: string = '';
  private memberGradeNo: string = '';
  private memberGroupNo: string = '';
  private includeClaim: string = 'false';
  private memberType: string = 'ALL';
  private showMemberShipGenderTypes: string = 'MALE,FEMALE,UNKNOWN';
  private showPlatformTypes: string = 'PC,MOBILE_WEB,MOBILE_APP';
  private depthData: DepthType[] = [];
  private today = new Date();
  private todayYear = this.today.getFullYear();
  private mid1Year: number = 2018;
  private mid2Year: number = 2019;
  private todayMonth = this.today.getMonth() + 1;
  private dateType: string = 'MONTH';
  private excelDownInfo = {};
  private members!: any[];
  private categoriesInfo = {
    selectedCategories: [] as any[],
    selected1Depth: 0,
    selected2Depth: 0,
    selected3Depth: 0,
    selected4Depth: 0,
    selected5Depth: 0,
    categoriesTree: []
  };

  private size: number = 100;
  private dateTypes = [
    {
      dateTypeValue: 'MONTH',
      dateTypeName: 'STATISTIC_SALES_MONTH'
    },
    {
      dateTypeValue: 'PERIOD',
      dateTypeName: 'STATISTIC_SALES_PERIOD'
    }
  ];
  private changeDateType() {
    if (this.dateType === 'PERIOD') {
    } else {
    }
  }

  private setDepthData(depth: number, allData: CategroyType[] = []): void {
    const idx = depth - 1;
    const data: CategroyType[] = [{value: '0', label: depth + 'Depth', children: []}];
    if (allData.length) {
      this.depthData[idx].data = data.concat(allData);
      this.depthData[idx].disabled = false;
    } else {
      this.depthData.push({data, disabled: true});
    }
  }

  private memberTypeList:{
    value: string;
    name: string;
  }[]=[]
  private async initDepthData(startIdx: number = 0) {
    this.mallNo = this.malls[0].mallNo;
    await this.$api.getStatisticsMemberTypes({params: {mallNo: this.mallNo.toString()}}).then(ret => {
      const {data} = ret;
      data.forEach((item) => {
        const temp = {
          value: '',
          name: ''
        };
        temp.value = item.type;
        temp.name = item.label;
        this.memberTypeList.push(temp)
      });
    });
    this.selectMall();
    if (startIdx === 0) {
      this.depthData = [];
      for (let i = 0, length = 4; i < length; i++) {
        this.setDepthData(i + 1);
      }
    } else {
      for (let i = startIdx, length = 4; i < length; i++) {
        const firstItem: CategroyType = {value: '0', label: i + 1 + 'Depth', children: []};
        this.depthData[i].data = [firstItem];
        this.depthData[i].disabled = true;
      }
    }
  }

  // private get memberTypeList() {
  //   let list: any = [
  //     {
  //       value: 'ALL',
  //       name: this.$t('STATISTIC_SALES_ALL')
  //     },
  //     {
  //       value: 'MALL',
  //       name: '쇼핑몰회원'
  //     },
  //     {
  //       value: 'PAYCO',
  //       name: 'PAYCO아이디회원'
  //     },
  //     {
  //       value: 'OPENID',
  //       name: 'OpenID 회원'
  //     },
  //     {
  //       value: 'NEOID',
  //       name: '통합관리회원'
  //     }
  //   ];
  //   return list;
  // }

  private mixinData = {
    memberGradeList: [],
    memberGroupList: []
  };
  private get grades() {
    const grades = [
      {
        value: 0,
        name: this.$t('STATISTIC_SALES_ALL')
      }
    ];
    //grades.splice(0,grades.length);
    if (this.mixinData.memberGradeList && this.mixinData.memberGradeList.length) {
      this.mixinData.memberGradeList.forEach((grade: Grade) => {
        if(grade.used==true){
          grades.push({
            value: grade.no,
            name: grade.name
          });
        }
      });
    }
    return grades;
  }
  private get groups() {
    const groups = [
      {
        value: 0,
        name: this.$t('STATISTIC_SALES_ALL')
      },
      {
        value: -1,
        name: this.$t('STATISTIC_SALES_PERIOD_GROUP_NOT_SET')
      }
    ];
    //groups.splice(0,groups.length);
    if (this.mixinData.memberGroupList && this.mixinData.memberGroupList.length) {
      this.mixinData.memberGroupList.forEach((group: Group) => {
        groups.push({
          value: group.no,
          name: group.name
        });
      });
    }
    return groups;
  }
  private get memberGroupList() {
    const list: any = [
      {
        value: 0,
        name: 'TEST'
      }
    ];
    return list;
  }
  private get includeClaimList() {
    const list: any = [
      {
        value: 'false',
        name: this.$t('STATISTIC_SALES_SELECT_FALSE')
      },
      {
        value: 'true',
        name: this.$t('STATISTIC_SALES_SELECT_TRUE')
      }
    ];
    return list;
  }
  private get mallList() {
    const list: any = [];
    if (this.malls) {
      this.malls.forEach(mall => {
        if (mall.used) {
          list.push({
            value: mall.mallNo,
            name: mall.mallName
          });
        }
      });
    }

    return list;
  }

  // 초기화
  private reset() {
    this.includeClaim = 'false';
    this.mallNo = this.malls[0].mallNo;
    this.memberType = String(this.memberTypeList[0].value);
    this.showMemberShipGenderTypes = 'MALE,FEMALE,UNKNOWN';
    (this.$refs.memberShipGender as any).setValues('ALL', 'MALE', 'FEMALE', 'UNKNOWN');
    this.showPlatformTypes = 'ALL';
    (this.$refs.issuablePlatform as any).setValues('ALL', 'PC', 'MOBILE_WEB', 'MOBILE_APP');
    this.getGrades();
    this.getGroups();
    this.dateType = 'PERIOD';
    this.startDate = addMonth(new Date(), -1);
    this.endDate = getToday();
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.partnerName = '';
    this.brandName = '';
    this.dateType = 'MONTH';
    this.selectedBrand = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'BRAND'
    };
    this.selectedPartner = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'PARTNER'
    };
    this.categoriesInfo.selected1Depth = 0;
    this.categoryDepthNm = '';
    (this.$refs.brandSearcherRef as BrandSearcher)?.resetBrand();
  }

  private get notReadyEditFlg() {
    const disablFlg = false;
    return disablFlg;
  }

  private memberShipGenderTypes = {
    name: 'memberShipGenderTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'MALE,FEMALE,UNKNOWN',
        dispaly: 'COMMON_ALL_CHECK'
      },
      {
        id: 'MALE',
        value: 'MALE',
        dispaly: 'STATISTIC_SALES_MALE'
      },
      {
        id: 'FEMALE',
        value: 'FEMALE',
        dispaly: 'STATISTIC_SALES_FEMALE'
      },
      {
        id: 'UNKNOWN',
        value: 'UNKNOWN',
        dispaly: 'STATISTIC_SALES_UNCLASSIFIED'
      }
    ]
  };
  private platformTypes = {
    name: 'platformTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'PC,MOBILE_WEB,MOBILE_APP',
        dispaly: 'COMMON_ALL_CHECK'
      },
      {
        id: 'PC',
        value: 'PC',
        dispaly: 'STATISTIC_SALES_PLATFORM_TYPE_PC'
      },
      {
        id: 'MOBILE_WEB',
        value: 'MOBILE_WEB',
        dispaly: 'STATISTIC_SALES_PLATFORM_TYPE_MOBILE_WEB'
      },
      {
        id: 'MOBILE_APP',
        value: 'MOBILE_APP',
        dispaly: 'STATISTIC_SALES_PLATFORM_TYPE_MOBILE_APP'
      }
    ]
  };
  private year: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2017 ? new Date().getFullYear() - 5 : 2017;
  private get yearList() {
    const years = [];
    const todayYear = new Date().getFullYear();
    for (let i = this.beginYear; i <= todayYear; i++) {
      years.push({
        value: i,
        name: `${i}${this.$t('COMMON_YEAR')}`
      });
    }
    return years;
  }
  private month: number = new Date().getMonth() + 1;
  private get monthList() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      months.push({
        value: i,
        name: `${i}${this.$t('COMMON_MONTH')}`
      });
    }
    return months;
  }

  private startDate: string = addMonth(new Date(), -1);
  private endDate: string = getToday();
  private periodOption = {
    havePeriodBtn: true,
    dateType: 'Ymd',
    period: '1m',
    periodTypes: ['td', 'ytd', '1w', '1m']
  };

  private created() {
    this.initDepthData();
  }
  private categoryDepthNm: string = ''

  private async searchBtnClick(page: number = 1, size: number) {
    if (this.showMemberShipGenderTypes === '') {
      alert(this.$t('VERIFY_MESSAGE_GENDER'));
      return false;
    }
    if (size) {
      this.size = size;
    }
    let categoryDepth = '';
    let categoryNo = '';
    if (this.categoriesInfo.selected1Depth && this.categoriesInfo.selected1Depth > 0) {
      categoryDepth = '1';
      categoryNo = this.categoriesInfo.selected1Depth.toString();
      this.depth1List.forEach((item) => {
        if (item.value.toString() == categoryNo){
          this.categoryDepthNm = item.name
        }
      });
    }
    if (this.categoriesInfo.selected2Depth && this.categoriesInfo.selected1Depth > 0) {
      categoryDepth = '2';
      categoryNo = this.categoriesInfo.selected2Depth.toString();
      this.depth2List.forEach((item) => {
        if (item.value.toString() == categoryNo){
          this.categoryDepthNm = this.categoryDepthNm + '>' + item.name
        }
      });
    }
    if (this.categoriesInfo.selected3Depth && this.categoriesInfo.selected1Depth > 0) {
      categoryDepth = '3';
      categoryNo = this.categoriesInfo.selected3Depth.toString();
      this.depth3List.forEach((item) => {
        if (item.value.toString() == categoryNo){
          this.categoryDepthNm = this.categoryDepthNm + '>' + item.name
        }
      });
    }
    if (this.categoriesInfo.selected4Depth && this.categoriesInfo.selected1Depth > 0) {
      categoryDepth = '4';
      categoryNo = this.categoriesInfo.selected4Depth.toString();
      this.depth4List.forEach((item) => {
        if (item.value.toString() == categoryNo){
          this.categoryDepthNm = this.categoryDepthNm + '>' + item.name
        }
      });
    }
    let startYmd = '';
    let endYmd = '';
    let startDateTime = '';
    let endDateTime = '';
    if (this.dateType === 'MONTH') {
      const tempDates = getFirstAndEndDay(this.year, this.month);
      startDateTime = tempDates.startYmd;
      endDateTime = tempDates.endYmd;
    } else if (this.dateType === 'PERIOD') {
      startDateTime = (this.$refs.combinedPeriod as any).startYmdt;
      endDateTime = (this.$refs.combinedPeriod as any).endYmdt;
    }
    startYmd = startDateTime;
    endYmd = endDateTime;
    // if ( this.dateType != 'MONTH' && (this.month = new Date().getMonth() + 1)){
    //   endYmd = changeDateFormat(new Date(), 'YYYY-MM-DD');
    // } else {
    //   endYmd = endDateTime;
    // }

    const request: GetStatisticsSalesCategoryRequest = {
      params: {
        categoryDepth: categoryDepth,
        categoryNo: categoryNo,
        displayBrandNo: this.selectedBrand.targetNo,
        displayCategoryNo: '',
        endYmd: endYmd,
        genderTypes: this.showMemberShipGenderTypes === 'ALL' ? 'MALE,FEMALE,UNKNOWN' : this.showMemberShipGenderTypes,
        includesClaim: this.includeClaim,
        mallNo: this.mallNo.toString(),
        memberGradeNo: this.memberGradeNo,
        memberGroupNo: this.memberGroupNo,
        memberType: this.memberType,
        page: page.toString(),
        partnerNo: this.selectedPartner.targetNo,
        payType: '',
        platformTypes: this.showPlatformTypes === 'ALL' ? 'PC,MOBILE_WEB,MOBILE_APP' : this.showPlatformTypes,
        productNos: '',
        productType: '',
        saleMethodType: '',
        size: this.size.toString(),
        startYmd: startYmd
      }
    };

    const request1: GetStatisticsSalesCategorySummaryRequest = {
      params: {
        categoryDepth: categoryDepth,
        categoryNo: categoryNo,
        displayBrandNo: this.selectedBrand.targetNo,
        displayCategoryNo: '',
        endYmd: endYmd,
        genderTypes: this.showMemberShipGenderTypes === 'ALL' ? 'MALE,FEMALE,UNKNOWN' : this.showMemberShipGenderTypes,
        includesClaim: this.includeClaim,
        mallNo: this.mallNo.toString(),
        memberGradeNo: this.memberGradeNo,
        memberGroupNo: this.memberGroupNo,
        memberType: this.memberType,
        page: page.toString(),
        partnerNo: this.selectedPartner.targetNo,
        payType: '',
        platformTypes: this.showPlatformTypes === 'ALL' ? 'PC,MOBILE_WEB,MOBILE_APP' : this.showPlatformTypes,
        productNos: '',
        productType: '',
        saleMethodType: '',
        size: this.size.toString(),
        startYmd: startYmd
      }
    };
    $('#loading').show();
    let mallName = '';
    this.malls.forEach((mallInfo: Mall) => {
      if (mallInfo.mallNo === Number(this.mallNo)) {
        mallName = mallInfo.mallName;
        return;
      }
    });
    let categorycontents: GetStatisticsSalesCategory;
    this.$api.getStatisticsSalesCategory(request).then(ret => {
      const {data} = ret;
      categorycontents = data;
      if (this.categoryDepthNm!=null && this.categoryDepthNm!=''){
        categorycontents.contents.forEach((item)=>{
          item.categoryName = this.categoryDepthNm + '>' + item.categoryName
        })
      }

      let categorySummarycontents: GetStatisticsSalesCategorySummary;
      this.$api.getStatisticsSalesCategorySummary(request1).then(ret => {
        const {data} = ret;
        categorySummarycontents = data;
        this.$emit('setSearchRequest', JSON.stringify(request));
        this.$emit('setData', categorycontents, categorySummarycontents, page, this.size, mallName);
      });
    });

    $('#loading').hide();
  }
  private partnerResult: any[] = [];
  private showResult: boolean = false;
  private selectedPartner = {
    targetName: '',
    targetNo: '',
    couponTargetType: 'PARTNER'
  };

  private partners: Partner[] = [];
  private searchPartner = debounce((e:Event) => this.searchPartnerByKeyword(e), 500);
  private async searchPartnerByKeyword(e) {
    const value = (e.target as HTMLInputElement).value;

    if (this.mallNo === undefined) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));
      this.$emit('focusMallNo');
    } else {
      const isSelectedPartner = value === this.selectedPartner?.targetName;
      if(!value) {
        this.partnerResult = [];
        this.selectedPartner = {
          targetName: '',
          targetNo: '',
          couponTargetType: 'PARTNER'
        };
        this.partnerName = '';    
        return;
      }
      if (isSelectedPartner) return;
      
      const request : GetPartnersRequest = {
        params: {
          searchType: PARTNERS_SEARCH_TYPE.partnerName,
          keyword: value,
          mallNo: Number(this.mallNo),
          startDateTime: `${DEFAULT_DATE_RANGE.MIN} ${DEFAULT_TIME_RANGE.START}`,
          endDateTime: `${DEFAULT_DATE_RANGE.MAX} ${DEFAULT_TIME_RANGE.END}`,
          partnerStatus: PARTNERS_STATUS.active,
          contractStatuses: PARTNERS_STATUS.active + ',' + PARTNERS_STATUS.suspend,
        }
      };
      const { data } = await this.$api.getPartners(request)
      this.partners = data.contents;

      this.partnerName = value;
      this.partnerResult = [];
      this.selectedPartner = null;
      this.showResult = true;

      const filteredPartnerName = this.partners.filter(({partnerName}) => (
        partnerName.replace(new RegExp(value, 'gi'), '') !== partnerName
      ));
      filteredPartnerName.forEach(({ partnerName, partnerNo }) => {
        const showName = partnerName.replace(new RegExp(value, 'gi'), '<span>$&</span>');
        const searchedPartnerInfo = {
          showName,
          targetName: partnerName,
          targetNo: partnerNo
        }        
        this.partnerResult = [...this.partnerResult, searchedPartnerInfo]
      });
    }
  }
  private clickPartner(partner: any) {
    this.showResult = false;
    this.selectedPartner = {
      targetName: partner.targetName,
      targetNo: partner.targetNo,
      couponTargetType: 'PARTNER'
    };
    this.partnerName = partner.targetName;
  }
  // BRAND
  private selectedBrand = this.resetBrand;
  private get resetBrand(){
    return {
      targetName: '',
      targetNo: '',
      couponTargetType: 'BRAND'
    }
  }

  private async getGrades() {
    $('#loading').show();
    const memberGradesList = await this.$api.getMemberGrades({params: {mallNo: this.mallNo}});
    const sortGrade = await memberGradesList.data.sort((a: Grade, b: Grade) => a.order - b.order);
    this.mixinData.memberGradeList = sortGrade;
    this.memberGradeNo = this.grades[0].value.toString();
    $('#loading').hide();
  }

  private async getGroups() {
    $('#loading').show();
    const memberGroupsList = await this.$api.getMemberGroups({params: {mallNo: this.mallNo}});
    const sortGroup = await memberGroupsList.data.sort((a: Group, b: Group) => b.order - a.order);
    this.mixinData.memberGroupList = sortGroup;
    this.memberGroupNo = this.groups[0].value.toString();
    $('#loading').hide();
  }

  private async selectMall() {
    this.getGrades();
    this.getGroups();
    this.categoriesInfo = {
      selectedCategories: [],
      selected1Depth: 0,
      selected2Depth: 0,
      selected3Depth: 0,
      selected4Depth: 0,
      selected5Depth: 0,
      categoriesTree: []
    };
    if (this.mallNo) {
      await this.getDepthMallNo();
    }

    await this.$api.getStatisticsMemberTypes({params: {mallNo: this.mallNo.toString()}}).then(ret => {
      const {data} = ret;
      this.memberTypeList = []
      data.forEach((item) => {
        const temp = {
          value: '',
          name: ''
        };
        temp.value = item.type;
        temp.name = item.label;
        this.memberTypeList.push(temp)
      });
    });
  }
  private async getDepthMallNo() {
    // const categoriesResponse = await this.$api.getDisplayCategoriesTree({params: {mallNo: this.mallNo}});
    // this.categoriesInfo.categoriesTree = categoriesResponse.data;
    const standardCategoriesTree = await this.$api.getStandardCategoriesTree({params: {mallNo: this.mallNo.toString()}});
    this.standardTree = standardCategoriesTree.data.tree;
  }

  // CATEGORY
  private standardTree = [];
  private get depth1List() {
     const depth1 = [
      {
        value: 0,
        name: '1Depth',
        info: null as any
      }
    ];
    if (this.standardTree && this.standardTree.length > 0) {
      this.standardTree.forEach((item) => {
        depth1.push({
          value: item.categoryNo,
          name: item.name,
          info: item
        });
      });
    }

    return depth1;
    // let depth1 = [
    //   {
    //     value: 0,
    //     name: '1Depth',
    //     parentName: '',
    //     info: null as any
    //   }
    // ];
    // if (this.categoriesInfo.categoriesTree && this.categoriesInfo.categoriesTree.length > 0) {
    //   this.categoriesInfo.categoriesTree.forEach((item: DisplayCategoriesTree) => {
    //     depth1.push({
    //       value: item.displayCategoryNo,
    //       name: item.displayCategoryName,
    //       parentName: '',
    //       info: item
    //     });
    //   });
    // }
    // return depth1;
  }
  private get depth2List() {
    const depth2 = [
      {
        value: 0,
        name: '2Depth',
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected1Depth !== 0) {
      const depth1Item = this.depth1List.find((item: any) => item.value === this.categoriesInfo.selected1Depth);
      if (depth1Item && depth1Item.info.child.length) {
        depth1Item.info.child.forEach((item: any) => {
          const info = item;
          // if (this.categoryType === 'DISPLAY_CATEGORY') {
          //   info = {
          //     categoryNo: item.displayCategoryNo,
          //     name: item.displayCategoryName,
          //     child: item.children
          //   };
          // }
          depth2.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth2;
    // let depth2 = [
    //   {
    //     value: 0,
    //     name: '2Depth',
    //     parentName: '',
    //     info: null as any
    //   }
    // ];
    // if (this.categoriesInfo.selected1Depth !== 0) {
    //   this.depth1List.forEach((item: any) => {
    //     if (item.value === this.categoriesInfo.selected1Depth) {
    //       if (item.info.children.length) {
    //         item.info.children.forEach((item2: any) => {
    //           depth2.push({
    //             value: item2.displayCategoryNo,
    //             name: item2.displayCategoryName,
    //             parentName: item.name,
    //             info: item2
    //           });
    //         });
    //       }
    //     }
    //   });
    // }
    // return depth2;
  }
  private get depth3List() {
    const depth3 = [
      {
        value: 0,
        name: '3Depth',
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected2Depth !== 0) {
      const depth2Item = this.depth2List.find((item: any) => item.value === this.categoriesInfo.selected2Depth);
      if (depth2Item && depth2Item.info.child.length) {
        depth2Item.info.child.forEach((item: any) => {
          const info = item;
          depth3.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth3;
    // let depth3 = [
    //   {
    //     value: 0,
    //     name: '3Depth',
    //     parentName: '',
    //     info: null as any
    //   }
    // ];
    // if (this.categoriesInfo.selected2Depth !== 0) {
    //   this.depth2List.forEach((item: any) => {
    //     if (item.value === this.categoriesInfo.selected2Depth) {
    //       if (item.info.children.length) {
    //         item.info.children.forEach((item2: any) => {
    //           depth3.push({
    //             value: item2.displayCategoryNo,
    //             name: item2.displayCategoryName,
    //             parentName: `${item.parentName}>${item.name}`,
    //             info: item2
    //           });
    //         });
    //       }
    //     }
    //   });
    // }
    // return depth3;
  }
  private get depth4List() {
    const depth4 = [
      {
        value: 0,
        name: '4Depth',
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected3Depth !== 0) {
      const depth3Item = this.depth3List.find((item: any) => item.value === this.categoriesInfo.selected3Depth);
      if (depth3Item && depth3Item.info.child.length) {
        depth3Item.info.child.forEach((item: any) => {
          const info = item;
          depth4.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth4;
    // let depth4 = [
    //   {
    //     value: 0,
    //     name: '4Depth',
    //     parentName: '',
    //     info: null as any
    //   }
    // ];
    // if (this.categoriesInfo.selected3Depth !== 0) {
    //   this.depth3List.forEach((item: any) => {
    //     if (item.value === this.categoriesInfo.selected3Depth) {
    //       if (item.info.children.length) {
    //         item.info.children.forEach((item2: any) => {
    //           depth4.push({
    //             value: item2.displayCategoryNo,
    //             name: item2.displayCategoryName,
    //             parentName: `${item.parentName}>${item.name}`,
    //             info: item2
    //           });
    //         });
    //       }
    //     }
    //   });
    // }
    // return depth4;
  }

  private changeDepth1() {
    this.categoriesInfo.selected2Depth = 0;
    this.categoriesInfo.selected3Depth = 0;
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
    if (this.categoriesInfo.selected1Depth !== 0) {
      this.depth1List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected1Depth) {
          if (item.info.children.length === 0) {
            this.addSelectedCategories(item);
          }
        }
      });
    }
  }
  private changeDepth2() {
    this.categoriesInfo.selected3Depth = 0;
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
    if (this.categoriesInfo.selected2Depth !== 0) {
      this.depth2List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected2Depth) {
          if (item.info.children.length === 0) {
            this.addSelectedCategories(item);
          }
        }
      });
    }
  }
  private changeDepth3() {
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
    if (this.categoriesInfo.selected3Depth !== 0) {
      this.depth3List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected3Depth) {
          if (item.info.children.length === 0) {
            this.addSelectedCategories(item);
          }
        }
      });
    }
  }
  private changeDepth4() {
    this.categoriesInfo.selected5Depth = 0;
    if (this.categoriesInfo.selected4Depth !== 0) {
      this.depth4List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected4Depth) {
          if (item.info.children.length === 0) {
            this.addSelectedCategories(item);
          }
        }
      });
    }
  }

  private addSelectedCategories(item: any) {
    let haveFlg = false;
    this.categoriesInfo.selectedCategories.forEach((selectedItem: any) => {
      if (selectedItem.targetNo === item.value) {
        haveFlg = true;
      }
    });
    if (!haveFlg) {
      let targetName = item.name;
      if (item.parentName !== '') {
        targetName = `${item.parentName}>${targetName}`;
      }
      if (item.info.displayYn === 'N') {
        targetName += '<span class="ico_noshow"></span>';
      }

      this.categoriesInfo.selectedCategories.push({
        targetName,
        targetNo: item.value,
        couponTargetType: 'CATEGORY'
      });
    }
  }
  private delSelectedCategories(targetNo: any) {
    this.categoriesInfo.selectedCategories = this.categoriesInfo.selectedCategories.filter((item: any) => item.targetNo !== targetNo);
  }
  private closeResult() {
    this.showResult = false;
  }
}
